import React, { useEffect, useState } from 'react'
import { useQuery } from '@apollo/client'
import ContentHeader from '../../Components/Layout/ContentHeader'
import LayoutTable from '../../Components/Global/LayoutTable'
import { toastSweetAlert } from '../Helpers/ToastSweetAlert'
import ModalContentAux from '../Global/ModalContentAux'
import {
  arrayCategoryBlog,
  findArrayStatusBlog,
  findCategoryBlog,
  fnArraySelectStatusBlog,
} from '../../const/constBlogPost'
import BlogPostPreview from './BlogPostPreview'
import {
  DELETE_BLOG_POST,
  GET_ALL_BLOG_POSTS,
} from '../../graphql/BlogPosts/blogPosts'

const iconImage = 'fas fa-image'
const iconLink = 'fas fa-anchor'
const idModal = 'modalBlog'

export const BlogPosts = () => {
  const optionsStatusBlog = fnArraySelectStatusBlog()
  //STATES:
  const [pagePagination, setPagePagination] = useState({
    searchQuery: null,
    limit: 10,
    offset: 0,
    filters: {
      status_id: null,
      category: null,
    },
  })
  const [total, setTotal] = useState(0)
  const [dataToTable, setDataToTable] = useState([])
  const [modalContent, setModalContent] = useState({
    title: '',
    content: null,
  })

  //QUERIES:
  const { loading, error, data } = useQuery(GET_ALL_BLOG_POSTS, {
    variables: { ...pagePagination },
    fetchPolicy: 'no-cache',
  })

  //EFFECTS:
  useEffect(() => {
    if (!loading) {
      if (error)
        return toastSweetAlert({
          mode: 'error',
          message: error.message,
        })

      let list = []
      data.getAllBlogPosts?.rows.map((item) => {
        const found_current_status = findArrayStatusBlog(item.status_id)
        const colorStatus = found_current_status.classColorTxt ?? ' text-green'

        const category = findCategoryBlog(item?.category)

        return list.push({
          id: item.id,
          plantilla: item.layout,
          categoría: category?.label,
          titulo: item.title,
          'resumen contenido': item.summary_content,
          'con imagen': (
            <i
              className={`${iconImage} ${
                item?.image_file_id ? 'text-success' : 'text-danger'
              }`}
              style={{ fontSize: 25 }}
            />
          ),
          'enlace externo': (
            <i
              className={`${iconLink} ${
                item?.external_link ? 'text-success' : 'text-danger'
              }`}
              style={{ fontSize: 25 }}
            />
          ),
          estatus: (
            <>
              <i
                className={`fas fa-circle mr-1 customColorTxt-${colorStatus}`}
              />
              {found_current_status.labelMain}
            </>
          ),
          Prevista: (
            <button
              type="button"
              className="btn btn-sm btn-migrates"
              data-toggle="modal"
              data-target={`#${idModal}`}
              onClick={(e) => showModal({ type: 'previewForm', item })}
            >
              <i className="fab fa-wpforms"></i>
            </button>
          ),
        })
      })
      setDataToTable(list)
      setTotal(data.getAllBlogPosts.count)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, error, data])

  const showModal = async ({ type, item }) => {
    try {
      if (type === 'previewForm') {
        setModalContent({
          title: 'Prevista del blog',
          content: <BlogPostPreview id={parseInt(item.id)} />,
        })
      }
    } catch (error) {
      console.log({ error })
    }
  }

  const handleCloseModal = () => {
    setModalContent({ title: null, content: null })
  }

  const filterOnChangeSecond = (e,field) => {
    const filterSelected = e.target.value
    setPagePagination({
      ...pagePagination,
      filters: {
        ...pagePagination.filters,
        [field]: field !== 'category' ?parseInt(filterSelected): filterSelected,
      },
    })
  }

  return (
    <>
      <ContentHeader title="Blog" breadcrumb="" windowTitle="Blog post" />
      <LayoutTable
        title="Lista de blogs"
        hideId
        data={dataToTable}
        gql={DELETE_BLOG_POST}
        requery={GET_ALL_BLOG_POSTS}
        exportImportButton={false}
        totalCount={total}
        pagePagination={pagePagination}
        setPagePagination={setPagePagination}
        loadingData={loading}
        FilterBarPlaceholder="Buscar por titulo"
        hideDetails
        filter
        filterOnChange={(e)=>filterOnChangeSecond(e,'category')}
        filterOptions={[
          arrayCategoryBlog.map((item) => (
            <option value={item?.value} key={'category-'+item?.value}>
              {item.label}
            </option>
          )),
        ]}
        filterLabelText="Categoria"

        filterSecond
        filterOnChangeSecond={(e)=>filterOnChangeSecond(e,'status_id')}
        filterOptionsSecond={[
          optionsStatusBlog?.map((item) => (
            <option value={item?.value} key={'status-'+item?.value}>
              {item.label}
            </option>
          )),
        ]}
        filterLabelTextSecond="Estatus"
      />

      <span
        id={`spanModal${idModal}`}
        className="btn invisible"
        data-toggle="modal"
        data-target={'#' + idModal}
        data-backdrop="static"
        data-keyboard="false"
        data-dismiss="modal"
      />

      <ModalContentAux
        idModal={idModal}
        title={modalContent.title}
        size="extra"
        onClose={() => handleCloseModal()}
        content={modalContent.content}
        showBtnAcceptFooter={false}
        textBtnCancelFooter="Cerrar"
      />
    </>
  )
}

export default BlogPosts
